import { render } from "./RegeneratePassword.vue?vue&type=template&id=f136c082"
import script from "./RegeneratePassword.vue?vue&type=script&lang=js"
export * from "./RegeneratePassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/public/RegeneratePassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f136c082"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f136c082', __exports__)) {
    api.reload('f136c082', __exports__)
  }
  
  module.hot.accept("./RegeneratePassword.vue?vue&type=template&id=f136c082", () => {
    api.rerender('f136c082', render)
  })

}


export default __exports__